import { StorageKey } from "../../../enums/StorageKey";

// Resizable BukkuEditableTableV2
export default {
    storageKey: StorageKey.stock_values,
    // getReportLabel: () => t`Periodic Values`,
    getColumns: () => [
        {
            key: 'account',
            required: true,
            isResizable: true,
        },
    ],
};
